import {
  SearchIcon,
  LucideIcon,
  ShieldIcon,
  FileUpIcon,
  UsersIcon,
  Share2Icon,
  ListIcon,
  MessageSquareIcon,
  PlusCircleIcon,
  BrainIcon,
  ClockIcon,
  SettingsIcon,
} from "lucide-react";
import { UserProfileInfo } from "./api-client-generated-types";
import { TranslationKeys } from "../hooks/use-custom-translation";

type Submenu = {
  href: string;
  label: string;
  active?: boolean;
};

type Menu = {
  href: string;
  label: string;
  active?: boolean;
  icon: LucideIcon;
  submenus?: Submenu[];
};

type Group = {
  groupLabel: string;
  menus: Menu[];
};

export function getMenuList({
  user,
  t,
}: {
  user?: UserProfileInfo;
  t: (key: TranslationKeys) => string;
}): Group[] {
  const items: Group[] = [
    {
      groupLabel: t("rightNavBar.papers"),

      menus: [
        {
          href: "/search",
          label: t("rightNavBar.contestExams"),
          icon: SearchIcon,
        },
        {
          href: "/user-exams",
          label: t("rightNavBar.myExams"),
          icon: ShieldIcon,
        },
      ],
    },

    {
      groupLabel: t("rightNavBar.aiPersonalityInterviews"),

      menus: [
        {
          href: "/new-ai-interview",
          label: t("rightNavBar.newAiInterview"),
          icon: BrainIcon,
        },
        {
          href: "/my-ai-interviews",
          label: t("rightNavBar.myAiInterviews"),
          icon: ClockIcon,
        },
        ...(user?.isAdmin
          ? [
              {
                href: "/admin-ai-interviews",
                label: t("rightNavBar.adminAiInterviews"),
                icon: SettingsIcon,
              },
              {
                href: "/admin-ai-interview-for-testing",
                label: t("rightNavBar.adminAiInterviewForTesting"),
                icon: SettingsIcon,
              },
              {
                href: "/admin-ai-interview-template-management",
                label: t("rightNavBar.adminAiInterviewTemplateManagement"),
                icon: SettingsIcon,
              },
            ]
          : []),
      ],
    },
    {
      groupLabel: t("rightNavBar.conversations"),

      menus: [
        {
          href: "/new-conversation",
          label: t("rightNavBar.newConversation"),
          icon: PlusCircleIcon,
        },
        {
          href: "/my-conversations",
          label: t("rightNavBar.conversations"),
          icon: MessageSquareIcon,
        },
      ],
    },
  ];

  items.push({
    groupLabel: t("rightNavBar.sharings"),
    menus: [
      {
        href: "/my-groups",
        label: t("rightNavBar.myGroups"),
        icon: UsersIcon,
      },
      {
        href: "/my-exam-sharings",
        label: t("rightNavBar.mySharedPapers"),
        icon: Share2Icon,
      },
      {
        href: "/exams-shared-to-me",
        label: t("rightNavBar.sharedWithMePapers"),
        icon: Share2Icon,
      },
    ],
  });

  if (user?.isAtLeastOperator) {
    items.push({
      groupLabel: t("rightNavBar.administration"),
      menus: [
        {
          href: "/admin-search",
          label: t("rightNavBar.allPapers"),
          icon: ListIcon,
        },
        {
          href: "/import-contest-exam",
          label: t("rightNavBar.importPaper"),
          icon: FileUpIcon,
        },
        ...(user.isAdmin
          ? [
              {
                href: "/app-users",
                label: t("rightNavBar.appUsers"),
                icon: UsersIcon,
              },
            ]
          : []),
      ],
    });
  }

  return items;
}
